import { createContext } from "react";
import PropTypes from 'prop-types';
import { GAMEMODE } from '../../utils/constants'


export const VideoQuizConfigContext = createContext()

export default function VideoQuizConfigProvider(props) {
    const { children, ...config } = props

    return (
        <VideoQuizConfigContext.Provider value={config}>
            {children}
        </VideoQuizConfigContext.Provider>
    )
}

VideoQuizConfigProvider.propTypes = {
    children: PropTypes.node,
    gameMode: PropTypes.oneOf(Object.values(GAMEMODE)),
}